import React from 'react';

const LoadingSpinner = () => {
    return (
        <div className="Body">

        </div>
    );
};

export default LoadingSpinner;
